import React, { useState } from "react";
import cx from "classnames";
import styles from "../scss/DapQuestion.module.scss";
import { IDigitalQuestion, IQuestionOptionImage } from "../interfaces/IDigitalAdviceData";
import DAQuestionField from "./DAQuestionField";
import { ISumbitParams } from "./DigitalAdviceQuestion";
import Tooltip from "../../common/components/Tooltips/Tooltip";

interface IAdviceQuestion {
    question: IDigitalQuestion;
    showForm: boolean;
    onSubmit: (params: ISumbitParams) => Promise<void>;
    onMultiSubmit: (answerList: ISumbitParams[]) => Promise<void>;
    addFrameImage?: (image: IQuestionOptionImage, isAdded: boolean) => void;
    addMultipleFrameImages?: (images: IQuestionOptionImage[], isAdded: boolean) => void;
    setImagePlaceholders?: (images: IQuestionOptionImage[]) => void;
    resetFramePlaceholder?: () => void;
}

const DigitalAdviceQuestionForm: React.FC<IAdviceQuestion> = (props) => {
    const { question, showForm } = props;
    const [questionReady, setQuestionReady] = useState(false);

    return (
        <React.Fragment>
            <div
                className={cx(
                    "layout-flex-column--justify-centered",
                    styles["dap-question-form"],
                    {
                        [styles["hide-form"]]: !showForm
                    }
                )}>
                {questionReady && (
                    <div className={styles["form-title"]}>
                        <div
                            className={styles["form-title-label"]}
                            dangerouslySetInnerHTML={{
                                __html: question?.label || ""
                            }}></div>
                        {question?.tooltip && (
                            <Tooltip
                                className={styles["form-title-tooltip"]}
                                tooltipContent={question?.tooltip}
                            />
                        )}
                    </div>
                )}
                {questionReady && question?.subHeading && (
                    <p className={styles["form-subtitle"]}>{question?.subHeading}</p>
                )}

                {!!(question && question.id) && (
                    <DAQuestionField
                        question={question}
                        fieldReady={setQuestionReady}
                        onSubmit={props.onSubmit}
                        onMultiSubmit={props.onMultiSubmit}
                        addFrameImage={props.addFrameImage}
                        addMultipleFrameImages={props.addMultipleFrameImages}
                        setImagePlaceholders={props.setImagePlaceholders}
                        resetFramePlaceholder={props.resetFramePlaceholder}
                    />
                )}
            </div>
        </React.Fragment>
    );
};

export default DigitalAdviceQuestionForm;
